import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class DividendResolutionCriteria extends Model.CriteriaBase {
    static typeName = "DividendResolutionCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public startDate: Date | null = DateUtils.monthEnd(DateUtils.add(new Date(), { months: -1 }));

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public endDate: Date | null = DateUtils.monthEnd(DateUtils.add(new Date(), { months: -1 }));

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public dated: Date | null = null;

    @Rules.Required()
    public entityId: number | null = null;;

    @Attributes.Integer()
    public resolutionNumber: number = 0;

    @Attributes.Integer()
    public resolutionYear: number = new Date().getFullYear();

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<DividendResolutionCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Dividend Resolution Criteria";
    }
}